import React from "react"

import { colors } from "@bullseye/tailwind-config"

import { IconProps } from "./IconProps"

const HeartIcon: React.FC<IconProps> = ({
  scale = 1,
  lineScale = 1,
  color = colors.primary[950],
  ...svgProps
}) => (
  <svg
    viewBox="0 0 16 16"
    width={scale * 16}
    height={scale * 16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Heart"
    {...svgProps}
  >
    <path
      d="M13.8933 3.0726C13.5528 2.73193 13.1485 2.46169 12.7036 2.27732C12.2586 2.09295 11.7817 1.99805 11.3 1.99805C10.8183 1.99805 10.3414 2.09295 9.89643 2.27732C9.45145 2.46169 9.04717 2.73193 8.70666 3.0726L8 3.77926L7.29333 3.0726C6.60554 2.3848 5.67269 1.9984 4.7 1.9984C3.72731 1.9984 2.79446 2.3848 2.10666 3.0726C1.41887 3.76039 1.03247 4.69324 1.03247 5.66593C1.03247 6.63862 1.41887 7.57147 2.10666 8.25926L2.81333 8.96593L8 14.1526L13.1867 8.96593L13.8933 8.25926C14.234 7.91876 14.5042 7.51447 14.6886 7.0695C14.873 6.62453 14.9679 6.14759 14.9679 5.66593C14.9679 5.18427 14.873 4.70733 14.6886 4.26236C14.5042 3.81739 14.234 3.4131 13.8933 3.0726V3.0726Z"
      stroke={color}
      strokeWidth={lineScale * 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default HeartIcon
